import { SFXSettings } from "../../../contexts/SettingsContext";

export const SFX_LIST: Array<{ key: string; value: SFXSettings }> = [
  { key: "Order Placed", value: "order_placed" },
  { key: "Order Filled", value: "order_filled" },
  { key: "Order Cancelled", value: "order_cancelled" },
  { key: "Errors", value: "error" },
];
